/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var tileSource = _interopDefault(require('../mixin/tile-source'));
var vueHelpers = require('../util/vue-helpers');
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var minilo = require('../util/minilo');

var BingMapsSource = __ol__.source.BingMaps;
var BINGMAPS_MAX_ZOOM = 21;
var BINGMAPS_CULTURE = 'en-us';
/**
 * @vueProps
 */
var props = {
  /**
   * Enables hidpi tiles.
   * @type {boolean}
   */
  hidpi: {
    type: Boolean,
    default: false
  },
  /**
   * Culture code.
   * @type {string}
   */
  culture: {
    type: String,
    default: BINGMAPS_CULTURE
  },
  /**
   * Bing Maps API key.
   * @type {string}
   */
  apiKey: {
    type: String,
    required: true
  },
  /**
   * Type of imagery.
   * @type {string}
   */
  imagerySet: {
    type: String,
    required: true
  },
  maxZoom: {
    type: Number,
    default: BINGMAPS_MAX_ZOOM
  },
  url: String

  /**
   * @vueMethods
   */
};var methods = {
  /**
   * @return {ol.source.BingMaps}
   * @protected
   */
  createSource: function createSource() {
    return new BingMapsSource({
      cacheSize: this.cacheSize,
      hidpi: this.hidpi,
      culture: this.culture,
      key: this.apiKey,
      imagerySet: this.imagerySet,
      maxZoom: this.maxZoom,
      reprojectionErrorThreshold: this.reprojectionErrorThreshold,
      wrapX: this.wrapX,
      transition: this.transition,
      tileLoadFunction: this.tileLoadFunction
    });
  }
};

var watch = vueHelpers.makeWatchers(['apiKey', 'imagerySet'], function () {
  return function () {
    this.scheduleRecreate();
  };
});

var Source = {
  name: 'vl-source-bingmaps',
  mixins: [tileSource],
  props: props,
  methods: methods,
  watch: watch
};

var index = {
  Source: Source,
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Source, options);

    Vue.component(Source.name, Source);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/bingmaps-source/index.js
// module id = 513
// module chunks = 1